import React from "react";
import { UseFormRegister } from "react-hook-form";
import {
  CustomerBillingAddress,
  ReconciliationFormData,
} from "../ReconciliationModal";

export interface CampaignPOInputProps {
  businessAddresses: CustomerBillingAddress[];
  selectedBusinessId: string;
}

export const BusinessUnitInput = React.forwardRef<
  HTMLSelectElement,
  CampaignPOInputProps &
    Partial<ReturnType<UseFormRegister<ReconciliationFormData>>>
>(function BaseBusinessUnitInput(
  { businessAddresses, selectedBusinessId, name, onChange },
  ref
) {
  return (
    <>
      <h5>Business Unit</h5>
      <select
        name={name}
        onChange={onChange}
        data-testid="business-unit-select"
        ref={ref}
        defaultValue={selectedBusinessId}
      >
        {businessAddresses.map(({ name, id }) => (
          <option key={id} value={id}>
            {name}
          </option>
        ))}
      </select>
    </>
  );
});
